export default __webpack_public_path__ + "static/media/Vacas.1a92339d.jpeg";